import React from "react";
import MonogramTile from "./MonogramTile";
import { useI18n } from "../lib/i18n";

export default function GameStrip({ games, selected, onSelect }) {
  const { t } = useI18n();
  return (
    <div className="flex gap-4 overflow-x-auto pb-2 mb-6">
      <button data-testid="game-strip-all" onClick={() => onSelect("")}
        className={`shrink-0 w-36 h-20 rounded-lg border flex items-center justify-center text-sm font-semibold transition-colors ${selected === "" ? "border-[#D4AF37] text-[#D4AF37]" : "border-[#35353B] text-[#A8A8AD] hover:border-[#D4AF37]"}`}>
        {t("market.all_games")}
      </button>
      {games.map((g) => (
        <button key={g.id} data-testid={`game-strip-${g.slug}`} onClick={() => onSelect(g.id)}
          className={`group shrink-0 w-36 h-20 rounded-lg border overflow-hidden relative transition-colors ${selected === g.id ? "border-[#D4AF37]" : "border-[#35353B] hover:border-[#D4AF37]"}`}>
          <MonogramTile name={g.name} className="absolute inset-0 w-full h-full" textSize="text-2xl" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#101114] via-[#101114]/40 to-transparent" />
          <span className={`absolute bottom-2 left-3 right-3 text-left text-xs font-bold truncate ${selected === g.id ? "text-[#D4AF37]" : "text-[#F5F3ED]"}`}>{g.name}</span>
        </button>
      ))}
    </div>
  );
}
